import { render, staticRenderFns } from "./DrawerBack.vue?vue&type=template&id=fe46dca6"
import script from "./DrawerBack.vue?vue&type=script&lang=js"
export * from "./DrawerBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports